// @flow
const BOX_BLUE = '#0061d5';
const SEESEE = '#ccc';
const RESIN_TAG_TARGET = 'data-resin-target';

export { BOX_BLUE, SEESEE, RESIN_TAG_TARGET };
